import { Injectable, inject } from '@angular/core';
import {
    IRelatedProductsCallback,
    IRelatedProductsOptions,
    RelatedProductsService
} from '@df/catalog-ui/related-products/related-products.service';
import { AdvancedCommerce } from '../advanced-commerce.namespace';
import { AdvancedCommerceService } from '../advanced-commerce.service';

@Injectable({
    providedIn: 'root'
})
export class AdvancedCommerceRecommendationsEngine {
    protected advancedCommerceService = inject(AdvancedCommerceService);

    get(
        sourceIds: number[],
        cb: IRelatedProductsCallback,
        engineOptions: AdvancedCommerce.Engine.Recommendations.Options,
        _options: IRelatedProductsOptions
    ) {
        if (engineOptions) {
            this.advancedCommerceService
                .getRecommendations<number[]>(engineOptions, sourceIds)
                .then(cb)
                .catch(() => {
                    cb([]);
                });
        } else {
            cb([]);
        }
    }
}

RelatedProductsService.registerEngine(AdvancedCommerce.Engine.Id.recommendations, AdvancedCommerceRecommendationsEngine);
